export default __webpack_public_path__ + "static/media/Flood_Early_Warning.95c96786.webp";